import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import clsx from "clsx";

import styles from "./ButtonsSwitch.module.scss";

export interface IButtonsSwitchProps {
  buttonsData: {
    content: string;
    path: string;
  }[];
}

export const ButtonsSwitch: React.FC<IButtonsSwitchProps> = ({
  buttonsData,
}) => {
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <div className={styles.switch}>
      {buttonsData.map((b, i) => (
        <button
          key={i}
          className={clsx(
            styles.switch__item,
            (pathname.includes(b.path) || b.path.includes(pathname)) &&
              styles.active,
          )}
          onClick={() => history.push(b.path)}
        >
          {b.content}
        </button>
      ))}
    </div>
  );
};
export default ButtonsSwitch;
